var _circle, _path, _path2, _circle2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorPageBgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 946,
    height: 329,
    viewBox: "0 0 946 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 789.682,
    cy: 222.682,
    r: 28.682,
    fill: "#E46969"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 329c0-88.379 71.647-160 160-160h160v160H0z",
    fill: "#026"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M817.529 290.019c-49.995 49.995-131.04 49.98-181.019 0L546 199.51 636.51 109l181.019 181.019z",
    fill: "#105ED5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 139,
    r: 30,
    fill: "#A2A3AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M310.411 0L269 154.548l154.548 41.411C446.415 110.617 395.779 22.874 310.411 0z",
    fill: "#FFB066"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M390.237 186.527l-70.71 70.71 70.71 70.711c39.047-39.047 39.059-102.363 0-141.421z",
    fill: "#105ED5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M568.421 176.711L497.711 106 427 176.711c39.047 39.046 102.363 39.058 141.421 0z",
    fill: "#E46969"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M418 329h128V201c-70.682 0-128 57.296-128 128z",
    fill: "#FFB066"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M818 201v128h128c0-70.682-57.296-128-128-128z",
    fill: "#026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorPageBgImage);
export default __webpack_public_path__ + "static/media/error-page-bg-image.28f55755ca89efcf6944870499ff85e0.svg";
export { ForwardRef as ReactComponent };